import * as types from '../mutation-types'

// initial state
const state = {
  behaviorScore: localStorage.getItem('behaviorScore') ? localStorage.getItem('behaviorScore') : '0',
  totalViolationpCount: localStorage.getItem('totalViolationpCount') ? localStorage.getItem('totalViolationpCount') : '0'
}

// getters
const getters = {
  getBehaviorScore: state => state.behaviorScore,
  getTotalViolationpCount: state => state.totalViolationpCount
}

// mutations
const mutations = {
  [types.SET_BEHAVIOR_SCORE] (state, behaviorScore) {
    state.behaviorScore = behaviorScore
    localStorage.setItem('behaviorScore', behaviorScore)
  },
  [types.SET_TOTAL_VIOLATIONP_COUNT] (state, totalViolationpCount) {
    state.totalViolationpCount = totalViolationpCount
    localStorage.setItem('totalViolationpCount', totalViolationpCount)
  }
}
// actions
const actions = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
